import { Fancybox } from "@fancyapps/ui";
import Cookies from 'js-cookie'

const COOKIE_PAGELOAD_NAME = 'PopupContactPageload'
const COOKIE_NAME = 'PopupContactClosed'
const EL_SELECTOR = '#js-PopupContact'
const EL = document.querySelector(EL_SELECTOR)
const PAGE_LOADS_COUNT = Cookies.get(COOKIE_PAGELOAD_NAME) ? parseInt(Cookies.get(COOKIE_PAGELOAD_NAME)) : 1
const PAGE_LOADS_LIMIT = 1

if(EL){
  var DELAY_SECONDS = parseInt(EL.getAttribute('data-delay'))
  var COOKIE_EXPIRES_DAYS = parseInt(EL.getAttribute('data-expires'))
}

class PopupContact {
  constructor() {
    // this.show()

    if(!Cookies.get(COOKIE_PAGELOAD_NAME)){
      Cookies.set(COOKIE_PAGELOAD_NAME, 1, { expires: COOKIE_EXPIRES_DAYS })
    } else {
      Cookies.set(COOKIE_PAGELOAD_NAME, PAGE_LOADS_COUNT + 1, { expires: COOKIE_EXPIRES_DAYS })
    }

    if(!Cookies.get(COOKIE_NAME) && EL && PAGE_LOADS_COUNT >= (PAGE_LOADS_LIMIT - 1)){
      setTimeout(() => {
        this.show()
      }, DELAY_SECONDS * 1000);
    }
  }

  show = () => {
    Fancybox.show(
      [
        {
          src: EL,
          type: "inline"
        },
      ],
      {
        mainClass: "fancybox--newsletter",
        dragToClose: false,
        showClass: "fancybox-fadeIn",
        on: {
          'destroy': () => {
            this.setCloseCookie()
          }
        }
      }
    );
  }

  setCloseCookie = () => {
    Cookies.set(COOKIE_NAME, 'true', { expires: COOKIE_EXPIRES_DAYS })
  }
}

new PopupContact();
